import { Icon, Modal, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

export const GiftListModal = ({ isOpen, setIsOpen }) => {
  const { t } = useTranslation();
  const TEXT_LIST_ITEMS = [
    {
      text: t('giftListModalTextListItem1')
    },
    {
      text: t('giftListModalTextListItem2')
    },
    {
      text: t('giftListModalTextListItem1')
    }
  ];

  return (
    <Modal isOpen={isOpen} onRequestClose={setIsOpen} title={t('addressCollectionOnly')}>
      <S.ModalBody>
        <S.Content>
          <Typography variant="body1Bold">{t('giftListModalTitle')}</Typography>
          <Typography variant="body2">{t('giftListModalDesc')}</Typography>
        </S.Content>
        <S.List>
          {TEXT_LIST_ITEMS.map((item, idx) => (
            <S.ListItem key={`text-item-${idx}`}>
              <S.ListIcon>
                <Icon name="success" color="var(--color-bg-body)" />
              </S.ListIcon>
              <S.ListP>{item.text}</S.ListP>
            </S.ListItem>
          ))}
        </S.List>
      </S.ModalBody>
    </Modal>
  );
};
